import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const labelFlyOutFn = /* @__PURE__ */ createRecipe('labelFlyOut', {}, [])

const labelFlyOutVariantMap = {}

const labelFlyOutVariantKeys = Object.keys(labelFlyOutVariantMap)

export const labelFlyOut = /* @__PURE__ */ Object.assign(memo(labelFlyOutFn.recipeFn), {
  __recipe__: true,
  __name__: 'labelFlyOut',
  __getCompoundVariantCss__: labelFlyOutFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: labelFlyOutVariantKeys,
  variantMap: labelFlyOutVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, labelFlyOutVariantKeys)
  },
  getVariantProps: labelFlyOutFn.getVariantProps,
})